import React from 'react';

import _ from 'lodash';

import InputSurveyQuestionPrompt from './InputSurveyQuestionPrompt';

import './SurveyQuestionTableRow.scss';

class SurveyQuestionTableRow extends React.Component {
  onInputChange = value => {
    let surveyQuestion;

    if (value === null) {
      surveyQuestion = null;
    }
    else {
      surveyQuestion = _.cloneDeep(this.props.surveyQuestion);
      surveyQuestion.fields.structure.value = value;
    }

    this.props.onValueChange(surveyQuestion);
  }


  handleRemoveSurveyQuestionClick = () => {
    this.onInputChange(null);
  }


  render() {
    const {
      surveyQuestion,
      ident,
      inputId,
      editMode
    } = this.props;

    return (
      <div className="parkchirp--survey-question-table-row">
        <InputSurveyQuestionPrompt inputId={`${inputId}--${ident}`}
          key={ident}
          structure={surveyQuestion.fields.structure.value}
          ident={ident}
          editMode={editMode}
          onValueChange={this.onInputChange}
        />
        {(editMode) &&
          <div className="parkchirp--survey-question-table-row--action-container">
            <button type="button"
              className="parkchirp--button-as-link"
              onClick={this.handleRemoveSurveyQuestionClick}>
              Remove Survey Question
            </button>
          </div>
        }
      </div>
    );
  }
}
export default SurveyQuestionTableRow;
